import { get } from 'lodash-es';

import { splitAccessorPath } from '../../../core/utils/accessors/split-accessor-path.js';

type Reader = (datum: unknown) => unknown;

/**
 * Compiles a string accessor into a reader function.
 *
 * Flat keys return early with a direct property read. Nested paths are split
 * into their segments once, at build time, and the reader resolves against
 * those ready-made segments.
 * @internal
 */
export function makeAccessor(accessor: string): Reader;
export function makeAccessor(accessor?: string): Reader | undefined;
export function makeAccessor(accessor?: string): Reader | undefined {
  if (!accessor) {
    return undefined;
  }

  if (!/[[.]/.test(accessor)) {
    return (datum) => (datum as Record<string, unknown>)[accessor];
  }

  const path = splitAccessorPath(accessor);
  return (datum) => get(datum, path);
}
